<template>
  <div class="article-list">
    <article-item
        v-for="(item, index) in articleLists"
        :key="item.id"
        :ariaDetails="item"
        :childName="childName"
        :class="index + 1 === articleLists.length ? 'itemBorder' : ''"
        :index="index + 1"
        v-bind="$attrs"
        @headleClick="headleClick"
    ></article-item>
    <!--    京城名医视频-->
    <div v-show="showVideo">
      <foodVedio
          :key="$route.fullPath"
          ref="childVideo"
          :showVedio="showVideo"
          :videoDetail="doctorInfo"
          :videoId="doctorInfo.id"
          getContainer="#HorizontalScreen"
          isHfindex="true"
          @hideVedio="hideVideoEvent"
          @isUserLogin="isLogin"
          @videoFinish="videoFinish"
      />
    </div>
    <!-- 京城名医注册提示 -->
    <loginTip
        :show="doctorCheckLogin"
        @cancleWay="doctorCancelWay"
        @confirmWay="doctorConfirmWay"
    ></loginTip>
  </div>
</template>
<script>
import articleItem from './articleItem.vue'
import foodVedio from '@/views/contents/bjfamousdoctor/component/video.vue' //京城名医视频播放
import loginTip from '@/views/contents/calendar/component/logintip'
import {getmotherState, isUserLogin} from '@assets/js/common.js'
import {BuiedPointClick_Fn} from '@assets/js/BuriedPointEvent' //注册提示组件
export default {
  name: '',
  data() {
    return {
      showVideo: false,
      doctorInfo: {},
      ariaDetails: {},
      doctorCheckLogin: false,
    }
  },
  watch: {
    articleLists: {
      handler(newValue) {
        this.articleLists = newValue
        console.log(newValue, 'articleListsarticleLists')
      },
      deep: true,
      immediate: true,
    },
  },
  props: {
    articleLists: {
      type: Array,
      required: true,
    },
    childName: String,
    getContainer: String,
  },
  methods: {
    isUserLogin: isUserLogin,
    headleClick(data) {
      this.ariaDetails = data
      const source =
          this.$route.path === '/powderedMilk'
              ? 'powderedMilk'
              : this.$route.path === '/milkArticleLists'
                  ? 'milkArticleLists'
                  : 'powderedMilk'
      if (data.type === 1) {
        this.$router.push({
          path: '/baby/detail/' + data.articleId + '?source=' + source,
        })
      } else if (data.type === 2) {
        this.getVideoInfo()
      }
    },
    getVideoInfo() {
      const {code} = getmotherState()
      const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      this.$http.post(
          '/capital/details',
          {},
          {
            id: this.ariaDetails.articleId,
            crmId: userInfo?.crm_id,
            memberLevelCode: code,
          },
          (res) => {
            if (res.code === 200) {
              this.showVideo = true
              this.doctorInfo = res.data
              // debugger
              BuiedPointClick_Fn('milkinfo_videoplay_start', {
                content_title: res.data.name,
              })
            }
          },
          null,
          'lucky'
      )
    },
    // 京城名医注册弹窗确认
    doctorConfirmWay() {
      this.doctorCheckLogin = false
      this.$refs.childVideo.isLogin()
    },
    // 京城名医注册弹窗取消
    doctorCancelWay() {
      this.$refs.childVideo.Player.pause()
      this.$refs.childVideo.Player.currentTime = 9
      this.doctorCheckLogin = false
    },
    // 视频播放返回按钮
    hideVideoEvent() {
      // document.title = "";
      this.showVideo = false
    },
    // 京城名医是否登录
    isLogin() {
      if (this.isUserLogin()) {
        this.$refs.childVideo.Player.pause()
        this.doctorCheckLogin = true
      }
    },
    videoFinish(data) {
      BuiedPointClick_Fn('milkinfo_videoplay_end', {
        content_title: this.doctorInfo.name,
        video_duration: data.video_duration,
        is_finished: data.is_finished,
      })
    },
  },
  components: {
    articleItem,
    foodVedio,
    loginTip,
  },
}
</script>
<style lang="less" scoped>
::v-deep .article-list {
  //margin-top: 20px;
  display: flex;
  flex-direction: column;
}
</style>
